export enum UploadStatus {
	IDLE = "idle",
	UPLOADING = "uploading",
	UPLOADED = "uploaded",
	ERROR = "error",
}
